import { render, staticRenderFns } from "./PaymentSetup.vue?vue&type=template&id=658a5f2d"
import script from "./PaymentSetup.vue?vue&type=script&lang=js"
export * from "./PaymentSetup.vue?vue&type=script&lang=js"
import style0 from "./PaymentSetup.vue?vue&type=style&index=0&id=658a5f2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports